import React from 'react'

const Jva_method = () => {
    return (
        <div className='container'>
            <h1 class="h1">Difference between method overloading and method overriding in java</h1>
            <p>There are many differences between method overloading and method overriding in java. A list of
                  differences between method overloading and method overriding are given below:</p>

            <table class="alt">
                  <tbody>
                        <tr>
                              <th>No.</th>
                              <th>Method Overloading </th>
                              <th>Method Overriding</th>
                        </tr>
                        <tr>
                              <td>1)</td>
                              <td>Method overloading is used <em>to increase the readability</em> of the program.</td>
                              <td>Method overriding is used <em>to provide the specific implementation</em> of the
                                    method that is already provided by its super class.</td>
                        </tr>
                        <tr>
                              <td>2)</td>
                              <td>Method overloading is performed <em>within class</em>.</td>
                              <td>Method overriding occurs <em>in two classes</em> that have IS-A (inheritance)
                                    relationship.</td>
                        </tr>
                        <tr>
                              <td>3)</td>
                              <td>In case of method overloading, <em>parameter must be different</em>.</td>
                              <td>In case of method overriding, <em>parameter must be same</em>.</td>
                        </tr>
                        <tr>
                              <td>4)</td>
                              <td>Method overloading is the example of <em>compile time polymorphism</em>.</td>
                              <td>Method overriding is the example of <em>run time polymorphism</em>.</td>
                        </tr>
                        <tr>
                              <td>5)</td>
                              <td>In java, method overloading can't be performed by changing return type of the method
                                    only. <em>Return type can be same or different</em> in method overloading. But you
                                    must have to change the parameter.</td>
                              <td><em>Return type must be same or covariant</em> in method overriding.</td>
                        </tr>
                  </tbody>
            </table>
            

            <h2 class="h2">Java Method Overloading example</h2>
            <div class="containers">
                  <div class="dp-highlighter">
                        
                        <ul start="1" class="dp-j">
                              <li class="alt"><span><span
                                                class="keywords">class</span><span>&nbsp;OverloadingExample&#123;&nbsp;&nbsp;</span></span>
                              </li>
                              <li class=""><span><span class="keywords">static</span><span>&nbsp;</span><span
                                                class="keywords">int</span><span>&nbsp;add(</span><span
                                                class="keywords">int</span><span>&nbsp;a,</span><span
                                                class="keywords">int</span><span>&nbsp;b)&#123;</span><span
                                                class="keywords">return</span><span>&nbsp;a+b;&#123;&nbsp;&nbsp;</span></span>
                              </li>
                              <li class="alt"><span><span class="keywords">static</span><span>&nbsp;</span><span
                                                class="keywords">int</span><span>&nbsp;add(</span><span
                                                class="keywords">int</span><span>&nbsp;a,</span><span
                                                class="keywords">int</span><span>&nbsp;b,</span><span
                                                class="keywords">int</span><span>&nbsp;c)&#123;</span><span
                                                class="keywords">return</span><span>&nbsp;a+b+c;&#123;&nbsp;&nbsp;</span></span>
                              </li>
                              <li class=""><span>&#123;&nbsp;&nbsp;</span></li>
                        </ul>
                  </div>
            </div>

            <h2 class="h2">Java Method Overriding example</h2>
            <div class="containers">
                  <div class="dp-highlighter">
                       
                        <ul start="1" class="dp-j">
                              <li class="alt"><span><span
                                                class="keywords">class</span><span>&nbsp;Animal&#123;&nbsp;&nbsp;</span></span>
                              </li>
                              <li class=""><span><span
                                                class="keywords">void</span><span>&nbsp;eat()&#123;System.out.println(</span><span
                                                class="string">"eating..."</span><span>);&#123;&nbsp;&nbsp;</span></span>
                              </li>
                              <li class="alt"><span>&#123;&nbsp;&nbsp;</span></li>
                              <li class=""><span><span class="keywords">class</span><span>&nbsp;Dog&nbsp;</span><span
                                                class="keywords">extends</span><span>&nbsp;Animal&#123;&nbsp;&nbsp;</span></span>
                              </li>
                              <li class="alt"><span><span
                                                class="keywords">void</span><span>&nbsp;eat()&#123;System.out.println(</span><span
                                                class="string">"eating&nbsp;bread..."</span><span>);&#123;&nbsp;&nbsp;</span></span>
                              </li>
                              <li class=""><span>&#123;&nbsp;&nbsp;</span></li>
                        </ul>
                  </div>
            </div>

         

        </div>
    )
}

export default Jva_method
